var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"car-plate-binding"},_vm._l((_vm.carModel),function(j){return _c('div',{staticClass:"item",on:{"click":function($event){return _vm.selectModel(j)}}},[_vm._v(_vm._s(j.name)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }